import { render, staticRenderFns } from "./LfRequiredFiedsLegendComponent.vue?vue&type=template&id=374830d8&scoped=true"
import script from "./LfRequiredFiedsLegendComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./LfRequiredFiedsLegendComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./LfRequiredFiedsLegendComponent.vue?vue&type=style&index=0&id=374830d8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374830d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('374830d8')) {
      api.createRecord('374830d8', component.options)
    } else {
      api.reload('374830d8', component.options)
    }
    module.hot.accept("./LfRequiredFiedsLegendComponent.vue?vue&type=template&id=374830d8&scoped=true", function () {
      api.rerender('374830d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/fields/LfRequiredFiedsLegend/LfRequiredFiedsLegendComponent.vue"
export default component.exports